import Axios from "../../../redux/setupAxios";


//  const ORG_AUTH_LOGIN = "/Org/Auth/Login/";
//  const ORG_AUTH_LOGIN = "Store/User/Login/";
const ORG_AUTH_LOGIN = "Store/User/AdminLogin/";
export const ORG_AUTH_SIGNUP = "/Org/Auth/Signup/";
const ORG_AUTH_FORGET_PASSWORD = "/Org/Auth/ForgotPassword/";
const ORG_AUTH_RESEND_VERIFY_EMAIL = "/Org/Auth/Signup/ResendVerificationEmail/";
const ORG_AUTH_UPDATE_PASSWORD = "/Org/Auth/UpdatePassword/";
const ORG_AUTH_SIGNUP_RESEND_OTP = "/Org/Auth/Signup/ResendOTP/";
// const ORG_AUTH_SIGNUP_RESEND_OTP = "/Org/Auth/ResendOTP/";
const ORG_AUTH_VERIFY_OTP = "/Org/Auth/VerifyOTP/";
const ORG_AUTH_FORGET_PASSWORD_VERIFY_OTP = "/Org/Auth/ForgotPassword/VerifyOTP/";
const ORG_AUTH_FORGET_PASSWORD_VERIFY_EMAIL = "/Org/Auth/ForgotPassword/VerifyViaEmail/";
const ORG_USER_STATIC_COUNTRY_CODE_GET = "/Org/User/StaticCountryCode/Get/";
const ORG_AUTH_VERIFICATION_INPROGRESS = "Org/Auth/VerificationInProgress/";
const ORG_AUTH_REFRESH = "/Org/Auth/Refresh/";
const ORG_SERVICES_SERVICEINSTANCES_GET = "/Org/Services/ServiceInstances/Get/";
const GET_COUNTRY = "/country/";
//  const org_ids = localStorage.getItem("org_country_id");
export const ORG_AUTH_RESET_PASSWORD = "/Org/Auth/ResetPassword/"



export function verificationInprogress(code) {
  return Axios.get(ORG_AUTH_VERIFICATION_INPROGRESS + code + "/");
}

export function getCountryList() {
  return Axios.get(GET_COUNTRY + "?page_size=1000");
}

export function verifyForgetPasswordEmail(email, otp) {
  return Axios.post(ORG_AUTH_FORGET_PASSWORD_VERIFY_EMAIL, { email: email, code: otp });
}

export function getServiceInstance(id) {
  return Axios.get(ORG_SERVICES_SERVICEINSTANCES_GET + id + "/");
}

export function authLogin(password, username, org_instance_id, fetchCountryId) {
  const country_id = localStorage.getItem("org_country_id");
  const OrgInstanceValue = localStorage.getItem("org_instance_id");
  const deviceId = localStorage.getItem("device_id");
  const Fcmtoken = localStorage.getItem("fcm_token");

  const basePayload = {
    password: password,
    org_instance_id: OrgInstanceValue,
    device_id: deviceId,
    platform: "1",
  };

  // ✅ only add token if it exists
  if (Fcmtoken) {
    basePayload.token = Fcmtoken;
  }

  let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let regPhone = /^[+-]?\d*(?:[.,]\d*)?$/;

  if (regEmail.test(username)) {
    return Axios.post(ORG_AUTH_LOGIN, {
      ...basePayload,
      email: username,
      type: "email",
    });
  } else if (regPhone.test(username)) {
    return Axios.post(ORG_AUTH_LOGIN, {
      ...basePayload,
      phn_nbr: username,
      type: "phn_nbr",
      country_id: country_id,
    });
  } else {
    return Axios.post(ORG_AUTH_LOGIN, {
      ...basePayload,
      username: username,
      type: "username",
    });
  }

}

export function requestPassword(username, OrgInstanceValue) {
  const country_id = localStorage.getItem("org_country_id");
  let regEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let regPhone = /^[+-]?\d*(?:[.,]\d*)?$/;
  if (regEmail.test(username)) {
    return Axios.post(ORG_AUTH_FORGET_PASSWORD, {
      email: username,
      org_instance_id: OrgInstanceValue,
    });
  } else if (regPhone.test(username)) {
    return Axios.post(ORG_AUTH_FORGET_PASSWORD, {
      phn_nbr: username,
      // phn_nbr: username[0],
      org_instance_id: OrgInstanceValue,
      country_id: country_id,
      // country_id:fetchCountryId,
    });
  } else {
    return Axios.post(ORG_AUTH_FORGET_PASSWORD, {
      username: username,
      org_instance_id: OrgInstanceValue,
    });
  }
}
export function register(
  username,
  fname,
  lname,
  email,
  contry_code,
  phn_nbr,
  password,
  org_instance_id,
  node_id
) {
  return Axios.post(ORG_AUTH_SIGNUP, {
    // username: username,
    fname: fname,
    // lname: lname,
    email: email,
    country_id: contry_code,
    phn_nbr: phn_nbr,
    password: password,
    // org_instance_id:org_instance_id,
    // node_id: node_id,
  });
}

export function refreshAccessToken(refToken) {
  return Axios.post(ORG_AUTH_REFRESH, { refresh: refToken });
}

export function resendLinks(email) {
  return Axios.post(ORG_AUTH_RESEND_VERIFY_EMAIL, { email: email });
}
export function resendMblOTP(phn_nbr) {
  return Axios.post(ORG_AUTH_SIGNUP_RESEND_OTP, { mobilenumber: phn_nbr });
}
export function verifyMblOTP(data) {
  return Axios.post(ORG_AUTH_VERIFY_OTP, data);
}

export function forgetPasswordVerifyOTP(country_id, phn_nbr, OTP, OrgInstanceValue) {
  return Axios.post(ORG_AUTH_FORGET_PASSWORD_VERIFY_OTP, {
    country_id: country_id,
    phn_nbr: phn_nbr,
    org_instance_id: OrgInstanceValue,
    code: OTP,
  });
}
export function resetPassword(values, token) {
  return Axios.post(ORG_AUTH_RESET_PASSWORD, { values, token: token });
}
